<template>
  <div>
    <v-list-item v-if="baseRoute" link :to="itemRoute(baseRoute)">
      <v-list-item-title class="text-h6">
        {{ name }}
      </v-list-item-title>
      <v-list-item-subtitle>
        {{ title }}
      </v-list-item-subtitle>
    </v-list-item>
    <v-list-item v-else @click="navigateToBaseMenu">
      <v-list-item-title class="text-h6">
        {{ name }}
      </v-list-item-title>
      <v-list-item-subtitle>
        {{ title }}
      </v-list-item-subtitle>
    </v-list-item>

    <v-divider></v-divider>
    <v-list class="grow">
      <div v-for="item in items"
           :key="item.name">
        <v-list-group v-if="item.items" :value="true">
            <template #activator="{ props }">
              <v-list-item v-bind="props" :prepend-icon="item.icon">
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item>
            </template>
            <v-list-item
                v-for="subitem in item.items"
                :to="itemRoute(subitem.route)"
                :key="subitem.name"
                link
            >
              <v-list-item-title v-text="subitem.name"></v-list-item-title>
            </v-list-item>
        </v-list-group>
        <v-list-item
            v-else
            link
            :to="itemRoute(item.route)"
        >
          <v-list-item-title :id="'menu_'+item.name.toLowerCase()" v-text="item.name"></v-list-item-title>
        </v-list-item>
      </div>
    </v-list>
  </div>
</template>

<script>
import { getCurrentProjectId, withProjectQuery } from '@/util/projectRoute';

export default {
  name: "PageMenu",
  props: {
    name: {required: true},
    title: {required: true},
    items: {required: true},
    baseRoute: {default: null}
  },
  methods: {
    itemRoute(route) {
      return withProjectQuery(route, getCurrentProjectId(this.$store));
    },
    navigateToBaseMenu() {
      this.$emit('navigate');
    }
  }
}
</script>

<style scoped>

</style>